import { EventengineStopStackTracesService_stopStackTraceServiceGetEntity } from '@festina/moneyin-general-types/moneyin/hooks/EventengineStopStackTracesService_stopStackTraceServiceGetEntity'

export const useFetchMoneyInStackTrace =
  EventengineStopStackTracesService_stopStackTraceServiceGetEntity.useSuspenseQuery
